/**
 * @namespace
 * @property {string} res.errorMessage - api 中返回的报错信息
 */
/* eslint-disable */
import 'babel-polyfill'
/* eslint-enable */

import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import {sync} from 'vuex-router-sync'
// 引入 Plugins
import ElementUI from 'element-ui'
import './element-variables.scss'
import OpenFiles from './plugins/open-files'
// 引入 CKEditor (Vue 2 version)
import CKEditor from '@ckeditor/ckeditor5-vue2'
// 引入 VueClipBoard
import VueClipboards from 'vue-clipboards'
// 引入一些共用方法
import * as qm from 'src/utils/utils'
// 引入 jquery Sea
import 'bigsea'
// 引入轻芒自定义组件
import QmButton from 'src/components/common/qm-button'
import QmCard from 'src/components/common/qm-card'
import QmFormCard from 'src/components/common/qm-card-form'
import QmDescription from 'src/components/common/qm-description'
import QmIndicator from 'src/components/common/qm-indicator'
import QmAvatar from 'src/components/common/qm-avatar'
import QmImageUpload from 'src/components/common/qm-image-uploader'
import QmVideoUpload from 'src/components/common/qm-video-uploader'
import QmIcon from 'src/components/common/qm-icon'
// 引入 css
import 'static/css/main.scss'

Vue.component('icon', QmIcon)
Vue.component('qm-button', QmButton)
Vue.component('qm-card', QmCard)
Vue.component('qm-form-card', QmFormCard)
Vue.component('qm-indicator', QmIndicator)
Vue.component('qm-description', QmDescription)
Vue.component('qm-avatar', QmAvatar)
Vue.component('qm-image-uploader', QmImageUpload)
Vue.component('qm-video-uploader', QmVideoUpload)

sync(store, router)

Vue.use(ElementUI)
Vue.use(VueClipboards)
Vue.use(OpenFiles)
Vue.use(CKEditor)

// 自定义指令 绑定 background-image
Vue.directive('bgi', {
  bind(el, binding) {
    setTimeout(() => {
      el.style.backgroundImage = `url(${binding.value})`
      el.style.backgroundPosition = 'center'
      el.style.backgroundRepeat = 'no-repeat'
      el.style.backgroundSize = el.style.backgroundSize || 'contain'
    }, 100)
  },
  update(el, binding) {
    setTimeout(() => {
      el.style.backgroundImage = `url(${binding.value})`
      el.style.backgroundPosition = 'center'
      el.style.backgroundRepeat = 'no-repeat'
      el.style.backgroundSize = el.style.backgroundSize || 'contain'
    }, 100)
  },
  unbind(el) {
    el.style.backgroundImage = ''
  },
})
/**
 * 自定义指令，给一个 div 设定图片背景
 * @params params {string | object} 支持直接传 url，或者传一个参数对象
 * @params [params.url] {string} 图片 url
 * @params [params.mode] {string} 展示方式，同微信小程序的类型 values:['aspectFit', 'aspectFill', 'widthFill']
 * @params [params.width] {number} 图片的实际宽度
 * @params [params.height] {number} 图片的实际高度
 * @params [params.color] {String} 占位区域的背景色
 */
Vue.directive('qm-background', function(el, binding) {
  const params = binding.value
  let mode, url, color
  if (typeof params === 'object') {
    mode = params.mode
    color = params.color
    url = params.url
  } else {
    mode = 'aspectFit'
    url = params
  }
  if (url) {
    el.style.backgroundImage = `url(${url})`
  }
  if (color) {
    el.style.backgroundColor = color
  }
  el.style.backgroundRepeat = 'no-repeat'
  el.style.backgroundPosition = 'center'
  switch (mode) {
    case 'aspectFit':
      el.style.backgroundSize = 'contain'
      break
    case 'aspectFill':
      el.style.backgroundSize = 'cover'
      break
    case 'widthFill':
      el.style.backgroundSize = 'cover'
      break
  }
})
// 自定义指令 当点击当前元素外部时触发
Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    vnode.data.qm_callback = function(e) {
      e.stopPropagation()
    }
    el.addEventListener('click', vnode.data.qm_callback)
    document.body.addEventListener('click', binding.value)
  },

  unbind(el, binding, vnode) {
    el.removeEventListener('click', vnode.data.qm_callback)
    document.body.removeEventListener('click', binding.value)
  },
})

Vue.config.productionTip = false

// Suppress unhandled promise rejections from network errors (e.g. old domain images/APIs)
window.addEventListener('unhandledrejection', event => {
  if (event.reason && event.reason.message && event.reason.message.includes('Network Error')) {
    event.preventDefault()
    console.warn('[Suppressed] Network Error:', event.reason.config ? event.reason.config.url : '')
  }
})

/**
 * 直接执行.
 */
if (qm.initGA) {
  qm.initGA()
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
